import React, { createContext, useContext, useState } from 'react';

const ThemeContext = createContext(undefined);

export const ThemeProvider = ({ children }) => {
  const [isDarkOps, setIsDarkOps] = useState(false);
  const [language, setLanguage] = useState('en');
  const toggleDarkOps = () => setIsDarkOps((prev) => !prev);
  const toggleLanguage = () => setLanguage((prev) => (prev === 'en' ? 'es' : 'en'));

  return (
    <ThemeContext.Provider value={{ isDarkOps, toggleDarkOps, language, toggleLanguage }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) throw new Error('useTheme must be used within a ThemeProvider');
  return context;
};
